import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";

import Nav from "@/components/site/Nav";
import Footer from "@/components/site/Footer";
import Home from "@/pages/Home";
import Work from "@/pages/Work";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import Admin from "@/pages/Admin";

function Shell({ children, hideFooter = false }) {
  return (
    <div className="App min-h-screen flex flex-col bg-white">
      <Nav />
      <main className="flex-1">{children}</main>
      {!hideFooter && <Footer />}
    </div>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <Toaster
        position="top-right"
        toastOptions={{
          style: {
            borderRadius: 0,
            border: "1px solid #09090b",
            fontFamily: "JetBrains Mono, monospace",
            fontSize: 12,
            textTransform: "uppercase",
            letterSpacing: "0.1em",
          },
        }}
      />
      <Routes>
        <Route path="/" element={<Shell><Home /></Shell>} />
        <Route path="/work" element={<Shell><Work /></Shell>} />
        <Route path="/about" element={<Shell><About /></Shell>} />
        <Route path="/contact" element={<Shell><Contact /></Shell>} />
        <Route path="/admin" element={<Shell hideFooter><Admin /></Shell>} />
      </Routes>
    </BrowserRouter>
  );
}
